import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA } from '@angular/material/legacy-snack-bar';

@Component({
  selector: 'site-settings-error-page',
  templateUrl: './site-settings-error-page.component.html',
  styleUrls: ['./site-settings-error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SiteSettingsErrorPageComponent {
  constructor(@Optional() @Inject(MAT_SNACK_BAR_DATA) public sitePath: string) {}
}
